import React, { useEffect, useState } from 'react';
import './user.css';
import { getCurrentUserOrLogoutRedirect, signOut } from '../../auth';
import DropdownMenuPopup from '../../lib/dropdown/DropdownMenuPopup';
import { useNavigate } from 'react-router-dom';
import { Logger } from '@elyx-code/common-ts-utils';

interface ICurrentUserAvatarProps {
	profilePagePath: string;
}

const CurrentUserAvatar: React.FC<ICurrentUserAvatarProps> = ({
	profilePagePath,
}) => {
	const [user, setUser] = useState<any>(null);
	const navigate = useNavigate();

	useEffect(() => {
		const fetchCurrentUser = async () => {
			try {
				const user = await getCurrentUserOrLogoutRedirect();
				setUser(user);
			} catch (e) {
				Logger.log('Error getting user profile', e);
			}
		};
		fetchCurrentUser();
	}, []);

	// @ts-ignore
	const profilePath = profilePagePath.replace('{id}', user?.id || '');

	return (
		<div>
			<div id='own-user-avatar' className='user-avatar'>
				{user?.picture ? (
					<img src={user.picture} title='You' alt='User Avatar' />
				) : (
					<i className='fa-solid fa-user' title='You' />
				)}
			</div>
			<DropdownMenuPopup
				popupOptions={{
					anchorQuerySelector: '#own-user-avatar',
					placement: 'bottom',
				}}
				options={[
					{
						navigateTo: profilePath,
						label: 'Profile',
					},
					{
						onClick: async () => {
							await signOut();
							navigate('/auth/sign-in');
						},
						label: 'Logout',
					},
				]}
			/>
		</div>
	);
};

export default CurrentUserAvatar;
